const CtmZoomConfig = (() => {
  const theme = window.theme || {};
  const foxTheme = window.FoxTheme || {};
  const shopifyRoot = window.Shopify?.routes?.root || '/';
  const apiBaseUrl = theme.ctm?.apiBaseUrl || theme.tps?.baseUrl || foxTheme.ctm?.apiBaseUrl || '';
  const shopId = theme.ctm?.shopId || foxTheme.ctm?.shopId || '';
  const routes = theme.routes || foxTheme.routes || {};

  return {
    apiBaseUrl,
    shopId,
    cartAddUrl: routes.cart_add_url || `${shopifyRoot}cart/add.js`,
    checkoutUrl: `${shopifyRoot}checkout`
  };
})();

class CtmZoomCancel extends HTMLElement {
  constructor() {
    super();
    this.apiBaseUrl = CtmZoomConfig.apiBaseUrl;
    this.detailsCard = this.querySelector('.ctm-cancel-details-card');
    this.successCard = this.querySelector('.ctm-cancel-success');
    this.dateEl = this.querySelector('[data-cancel-date]');
    this.timeEl = this.querySelector('[data-cancel-time]');
    this.timezoneEl = this.querySelector('[data-cancel-timezone]');
    this.locationEl = this.querySelector('[data-cancel-location]');
    
    this.cancelBtn = this.querySelector('.ctm-btn-cancel-action');
    this.newApptBtn = this.querySelector('.ctm-btn-new-appointment');
    
    this.modal = this.querySelector('.ctm-zoom-cancel-modal');
    this.closeBtn = this.querySelector('.ctm-zoom-cancel-no');
    this.confirmBtn = this.querySelector('.ctm-zoom-cancel-yes');
    this.closeIcon = this.querySelector('.ctm-zoom-cancel-close');
    this.loadingOverlay = document.getElementById('loading-overlay');
    this.ctmToast = document.getElementById('ctm-toast');

    this.init();
  }

  _portalGlobalFeedback() {
    [this.loadingOverlay, this.ctmToast].forEach((el) => {
      if (el && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  async init() {
    this._portalGlobalFeedback();
    this.bindEvents();
    
    const data = await this.fetchBookingDetails();
    this.fillDetails(data);
  }

  bindEvents() {
    if (this.cancelBtn) {
        this.cancelBtn.addEventListener('click', () => this.showModal());
    }
    if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.hideModal());
    }
    if (this.closeIcon) {
        this.closeIcon.addEventListener('click', () => this.hideModal());
    }
    if (this.confirmBtn) {
        this.confirmBtn.addEventListener('click', () => {
            this.handleCancel();
        });
    }
    if (this.modal) {
        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.hideModal();
        });
        this.modal.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.hideModal();
        });
    }

    if (this.newApptBtn) {
        this.newApptBtn.addEventListener('click', () => {
             window.location.reload(); 
        });
    }
  }

  showModal() {
    if (this.modal) {
        this.previouslyFocusedElement = document.activeElement;
        this.modal.classList.add('active');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        this.closeIcon?.focus();
    }
  }

  hideModal() {
    if (this.modal) {
        this.modal.classList.remove('active');
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        this.previouslyFocusedElement?.focus?.();
    }
  }

  async _fetch(url, options = {}) {
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
      }
    };

    const mergedOptions = {
      ...defaultOptions,
      ...options,
      headers: { ...defaultOptions.headers, ...options.headers }
    };

    try {
      const response = await fetch(url, mergedOptions);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(`Fetch error [${url}]:`, error);
      throw error;
    }
  }

  async fetchBookingDetails() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (!token) return null;

    try {
      const data = await this._fetch(`${this.apiBaseUrl}/zoom-meetings/detail/${token}?shopId=${CtmZoomConfig.shopId}`);
      if (data.code === 200) {
        if (this.cancelBtn) this.cancelBtn.style.display = 'block';
        return data.data; 
      } else {
        if (this.ctmToast) this.ctmToast.show(data.message || 'Fetch details failed');
      }
    } catch (e) {
      console.error('Fetch details error:', e);
    }
    return null;
  }

  fillDetails(data) {
    if (!data) return;

    try {
      const parseDate = (dateStr) => {
        if (!dateStr) return new Date();
        if (dateStr.includes('T')) {
          return new Date(dateStr);
        }
        return new Date(dateStr.replace(/-/g, '/'));
      };

      const startDate = parseDate(data.zoomStartTime);
      const endDate = parseDate(data.zoomEndTime);

      const dateOptions = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
      const dateStr = startDate.toLocaleDateString('en-GB', dateOptions);

      const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
      const startTimeStr = startDate.toLocaleTimeString('en-GB', timeOptions);
      const endTimeStr = endDate.toLocaleTimeString('en-GB', timeOptions);
      const timeRange = `${startTimeStr} - ${endTimeStr}`;

      if (this.dateEl) this.dateEl.textContent = dateStr;
      if (this.timeEl) this.timeEl.textContent = timeRange;
      if (this.timezoneEl) this.timezoneEl.textContent = data.timezone;
      if (this.locationEl) {
          this.locationEl.textContent = "Zoom Meeting";
          this.locationEl.href = data.zoomJoinUrl;
      }
    } catch (e) {
      console.error('Format details error:', e);
    }
  }

  async handleCancel() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (!token) return;

    try {
      if (this.loadingOverlay) this.loadingOverlay.show('Cancelling...');
      
      const data = await this._fetch(`${this.apiBaseUrl}/zoom-meetings/cancel/${token}`, {
        method: 'POST',
        body: JSON.stringify({
          shopId: CtmZoomConfig.shopId
        })
      });
      
      if (data.code === 200) {
        this.hideModal();
        this.showSuccess();
      } else {
        if (this.ctmToast) this.ctmToast.show(data.message || 'Cancel failed');
      }
    } catch (e) {
      console.error('Cancel error:', e);
    } finally {
      if (this.loadingOverlay) this.loadingOverlay.hide();
    }
  }

  showSuccess() {
    if (this.detailsCard) this.detailsCard.style.display = 'none';
    if (this.successCard) this.successCard.style.display = 'block';
  }
}

if (!customElements.get('ctm-zoom-cancel')) {
  customElements.define('ctm-zoom-cancel', CtmZoomCancel);
}

const COUNTRY_LIST = [
  {code:"US",name:"United States",dial_code:"+1"},
  {code:"AF",name:"Afghanistan",dial_code:"+93"},
  {code:"AX",name:"Aland Islands",dial_code:"+358"},
  {code:"AL",name:"Albania",dial_code:"+355"},
  {code:"DZ",name:"Algeria",dial_code:"+213"},
  {code:"AS",name:"American Samoa",dial_code:"+1"},
  {code:"AD",name:"Andorra",dial_code:"+376"},
  {code:"AO",name:"Angola",dial_code:"+244"},
  {code:"AI",name:"Anguilla",dial_code:"+1"},
  {code:"AQ",name:"Antarctica",dial_code:""},
  {code:"AG",name:"Antigua and Barbuda",dial_code:"+1"},
  {code:"AR",name:"Argentina",dial_code:"+54"},
  {code:"AM",name:"Armenia",dial_code:"+374"},
  {code:"AW",name:"Aruba",dial_code:"+297"},
  {code:"AU",name:"Australia",dial_code:"+61"},
  {code:"AT",name:"Austria",dial_code:"+43"},
  {code:"AZ",name:"Azerbaijan",dial_code:"+994"},
  {code:"BS",name:"Bahamas",dial_code:"+1"},
  {code:"BH",name:"Bahrain",dial_code:"+973"},
  {code:"BD",name:"Bangladesh",dial_code:"+880"},
  {code:"BB",name:"Barbados",dial_code:"+1"},
  {code:"BY",name:"Belarus",dial_code:"+375"},
  {code:"BE",name:"Belgium",dial_code:"+32"},
  {code:"BZ",name:"Belize",dial_code:"+501"},
  {code:"BJ",name:"Benin",dial_code:"+229"},
  {code:"BM",name:"Bermuda",dial_code:"+1"},
  {code:"BT",name:"Bhutan",dial_code:"+975"},
  {code:"BO",name:"Bolivia",dial_code:"+591"},
  {code:"BQ",name:"Bonaire, Sint Eustatius and Saba",dial_code:"+599"},
  {code:"BA",name:"Bosnia and Herzegovina",dial_code:"+387"},
  {code:"BW",name:"Botswana",dial_code:"+267"},
  {code:"BV",name:"Bouvet Island",dial_code:""},
  {code:"BR",name:"Brazil",dial_code:"+55"},
  {code:"IO",name:"British Indian Ocean Territory",dial_code:"+246"},
  {code:"BN",name:"Brunei Darussalam",dial_code:"+673"},
  {code:"BG",name:"Bulgaria",dial_code:"+359"},
  {code:"BF",name:"Burkina Faso",dial_code:"+226"},
  {code:"BI",name:"Burundi",dial_code:"+257"},
  {code:"KH",name:"Cambodia",dial_code:"+855"},
  {code:"CM",name:"Cameroon",dial_code:"+237"},
  {code:"CA",name:"Canada",dial_code:"+1"},
  {code:"CV",name:"Cabo Verde",dial_code:"+238"},
  {code:"KY",name:"Cayman Islands",dial_code:"+1"},
  {code:"CF",name:"Central African Republic",dial_code:"+236"},
  {code:"TD",name:"Chad",dial_code:"+235"},
  {code:"CL",name:"Chile",dial_code:"+56"},
  {code:"CN",name:"China",dial_code:"+86"},
  {code:"CX",name:"Christmas Island",dial_code:"+61"},
  {code:"CC",name:"Cocos (Keeling) Islands",dial_code:"+61"},
  {code:"CO",name:"Colombia",dial_code:"+57"},
  {code:"KM",name:"Comoros",dial_code:"+269"},
  {code:"CG",name:"Congo",dial_code:"+242"},
  {code:"CD",name:"Congo, Democratic Republic of the",dial_code:"+243"},
  {code:"CK",name:"Cook Islands",dial_code:"+682"},
  {code:"CR",name:"Costa Rica",dial_code:"+506"},
  {code:"CI",name:"Côte d’Ivoire",dial_code:"+225"},
  {code:"HR",name:"Croatia",dial_code:"+385"},
  {code:"CU",name:"Cuba",dial_code:"+53"},
  {code:"CW",name:"Curaçao",dial_code:"+599"},
  {code:"CY",name:"Cyprus",dial_code:"+357"},
  {code:"CZ",name:"Czech Republic",dial_code:"+420"},
  {code:"DK",name:"Denmark",dial_code:"+45"},
  {code:"DJ",name:"Djibouti",dial_code:"+253"},
  {code:"DM",name:"Dominica",dial_code:"+1"},
  {code:"DO",name:"Dominican Republic",dial_code:"+1"},
  {code:"EC",name:"Ecuador",dial_code:"+593"},
  {code:"EG",name:"Egypt",dial_code:"+20"},
  {code:"SV",name:"El Salvador",dial_code:"+503"},
  {code:"GQ",name:"Equatorial Guinea",dial_code:"+240"},
  {code:"ER",name:"Eritrea",dial_code:"+291"},
  {code:"EE",name:"Estonia",dial_code:"+372"},
  {code:"SZ",name:"Eswatini",dial_code:"+268"},
  {code:"ET",name:"Ethiopia",dial_code:"+251"},
  {code:"FK",name:"Falkland Islands",dial_code:"+500"},
  {code:"FO",name:"Faroe Islands",dial_code:"+298"},
  {code:"FJ",name:"Fiji",dial_code:"+679"},
  {code:"FI",name:"Finland",dial_code:"+358"},
  {code:"FR",name:"France",dial_code:"+33"},
  {code:"GF",name:"French Guiana",dial_code:"+594"},
  {code:"PF",name:"French Polynesia",dial_code:"+689"},
  {code:"TF",name:"French Southern Territories",dial_code:""},
  {code:"GA",name:"Gabon",dial_code:"+241"},
  {code:"GM",name:"Gambia",dial_code:"+220"},
  {code:"GE",name:"Georgia",dial_code:"+995"},
  {code:"DE",name:"Germany",dial_code:"+49"},
  {code:"GH",name:"Ghana",dial_code:"+233"},
  {code:"GI",name:"Gibraltar",dial_code:"+350"},
  {code:"GR",name:"Greece",dial_code:"+30"},
  {code:"GL",name:"Greenland",dial_code:"+299"},
  {code:"GD",name:"Grenada",dial_code:"+1"},
  {code:"GP",name:"Guadeloupe",dial_code:"+590"},
  {code:"GU",name:"Guam",dial_code:"+1"},
  {code:"GT",name:"Guatemala",dial_code:"+502"},
  {code:"GG",name:"Guernsey",dial_code:"+44"},
  {code:"GN",name:"Guinea",dial_code:"+224"},
  {code:"GW",name:"Guinea-Bissau",dial_code:"+245"},
  {code:"GY",name:"Guyana",dial_code:"+592"},
  {code:"HT",name:"Haiti",dial_code:"+509"},
  {code:"HN",name:"Honduras",dial_code:"+504"},
  {code:"HK",name:"Hong Kong",dial_code:"+852"},
  {code:"HU",name:"Hungary",dial_code:"+36"},
  {code:"IS",name:"Iceland",dial_code:"+354"},
  {code:"IN",name:"India",dial_code:"+91"},
  {code:"ID",name:"Indonesia",dial_code:"+62"},
  {code:"IR",name:"Iran",dial_code:"+98"},
  {code:"IQ",name:"Iraq",dial_code:"+964"},
  {code:"IE",name:"Ireland",dial_code:"+353"},
  {code:"IM",name:"Isle of Man",dial_code:"+44"},
  {code:"IL",name:"Israel",dial_code:"+972"},
  {code:"IT",name:"Italy",dial_code:"+39"},
  {code:"JM",name:"Jamaica",dial_code:"+1"},
  {code:"JP",name:"Japan",dial_code:"+81"},
  {code:"JE",name:"Jersey",dial_code:"+44"},
  {code:"JO",name:"Jordan",dial_code:"+962"},
  {code:"KZ",name:"Kazakhstan",dial_code:"+7"},
  {code:"KE",name:"Kenya",dial_code:"+254"},
  {code:"KI",name:"Kiribati",dial_code:"+686"},
  {code:"KP",name:"Korea (North)",dial_code:"+850"},
  {code:"KR",name:"Korea (South)",dial_code:"+82"},
  {code:"KW",name:"Kuwait",dial_code:"+965"},
  {code:"KG",name:"Kyrgyzstan",dial_code:"+996"},
  {code:"LA",name:"Lao People's Democratic Republic",dial_code:"+856"},
  {code:"LV",name:"Latvia",dial_code:"+371"},
  {code:"LB",name:"Lebanon",dial_code:"+961"},
  {code:"LS",name:"Lesotho",dial_code:"+266"},
  {code:"LR",name:"Liberia",dial_code:"+231"},
  {code:"LY",name:"Libya",dial_code:"+218"},
  {code:"LI",name:"Liechtenstein",dial_code:"+423"},
  {code:"LT",name:"Lithuania",dial_code:"+370"},
  {code:"LU",name:"Luxembourg",dial_code:"+352"},
  {code:"MO",name:"Macao",dial_code:"+853"},
  {code:"MG",name:"Madagascar",dial_code:"+261"},
  {code:"MW",name:"Malawi",dial_code:"+265"},
  {code:"MY",name:"Malaysia",dial_code:"+60"},
  {code:"MV",name:"Maldives",dial_code:"+960"},
  {code:"ML",name:"Mali",dial_code:"+223"},
  {code:"MT",name:"Malta",dial_code:"+356"},
  {code:"MH",name:"Marshall Islands",dial_code:"+692"},
  {code:"MQ",name:"Martinique",dial_code:"+596"},
  {code:"MR",name:"Mauritania",dial_code:"+222"},
  {code:"MU",name:"Mauritius",dial_code:"+230"},
  {code:"YT",name:"Mayotte",dial_code:"+262"},
  {code:"MX",name:"Mexico",dial_code:"+52"},
  {code:"FM",name:"Micronesia",dial_code:"+691"},
  {code:"MD",name:"Moldova",dial_code:"+373"},
  {code:"MC",name:"Monaco",dial_code:"+377"},
  {code:"MN",name:"Mongolia",dial_code:"+976"},
  {code:"ME",name:"Montenegro",dial_code:"+382"},
  {code:"MS",name:"Montserrat",dial_code:"+1"},
  {code:"MA",name:"Morocco",dial_code:"+212"},
  {code:"MZ",name:"Mozambique",dial_code:"+258"},
  {code:"MM",name:"Myanmar",dial_code:"+95"},
  {code:"NA",name:"Namibia",dial_code:"+264"},
  {code:"NR",name:"Nauru",dial_code:"+674"},
  {code:"NP",name:"Nepal",dial_code:"+977"},
  {code:"NL",name:"Netherlands",dial_code:"+31"},
  {code:"NC",name:"New Caledonia",dial_code:"+687"},
  {code:"NZ",name:"New Zealand",dial_code:"+64"},
  {code:"NI",name:"Nicaragua",dial_code:"+505"},
  {code:"NE",name:"Niger",dial_code:"+227"},
  {code:"NG",name:"Nigeria",dial_code:"+234"},
  {code:"NU",name:"Niue",dial_code:"+683"},
  {code:"NF",name:"Norfolk Island",dial_code:"+672"},
  {code:"MK",name:"North Macedonia",dial_code:"+389"},
  {code:"MP",name:"Northern Mariana Islands",dial_code:"+1"},
  {code:"NO",name:"Norway",dial_code:"+47"},
  {code:"OM",name:"Oman",dial_code:"+968"},
  {code:"PK",name:"Pakistan",dial_code:"+92"},
  {code:"PW",name:"Palau",dial_code:"+680"},
  {code:"PS",name:"Palestine",dial_code:"+970"},
  {code:"PA",name:"Panama",dial_code:"+507"},
  {code:"PG",name:"Papua New Guinea",dial_code:"+675"},
  {code:"PY",name:"Paraguay",dial_code:"+595"},
  {code:"PE",name:"Peru",dial_code:"+51"},
  {code:"PH",name:"Philippines",dial_code:"+63"},
  {code:"PL",name:"Poland",dial_code:"+48"},
  {code:"PT",name:"Portugal",dial_code:"+351"},
  {code:"PR",name:"Puerto Rico",dial_code:"+1"},
  {code:"QA",name:"Qatar",dial_code:"+974"},
  {code:"RE",name:"Réunion",dial_code:"+262"},
  {code:"RO",name:"Romania",dial_code:"+40"},
  {code:"RU",name:"Russian Federation",dial_code:"+7"},
  {code:"RW",name:"Rwanda",dial_code:"+250"},
  {code:"SA",name:"Saudi Arabia",dial_code:"+966"},
  {code:"SG",name:"Singapore",dial_code:"+65"},
  {code:"ZA",name:"South Africa",dial_code:"+27"},
  {code:"ES",name:"Spain",dial_code:"+34"},
  {code:"SE",name:"Sweden",dial_code:"+46"},
  {code:"CH",name:"Switzerland",dial_code:"+41"},
  {code:"TW",name:"Taiwan",dial_code:"+886"},
  {code:"TH",name:"Thailand",dial_code:"+66"},
  {code:"TR",name:"Turkey",dial_code:"+90"},
  {code:"UA",name:"Ukraine",dial_code:"+380"},
  {code:"AE",name:"United Arab Emirates",dial_code:"+971"},
  {code:"GB",name:"United Kingdom",dial_code:"+44"},
  {code:"UY",name:"Uruguay",dial_code:"+598"},
  {code:"UZ",name:"Uzbekistan",dial_code:"+998"},
  {code:"VN",name:"Viet Nam",dial_code:"+84"},
  {code:"YE",name:"Yemen",dial_code:"+967"},
  {code:"ZM",name:"Zambia",dial_code:"+260"},
  {code:"ZW",name:"Zimbabwe",dial_code:"+263"}
];


class FileUploader {
  constructor(options = {}) {
    this.apiBaseUrl = CtmZoomConfig.apiBaseUrl;

    this.maxFiles = 10; 
    this.maxFileSize = options.maxFileSize || 5 * 1024 * 1024; 
    this.validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    this.uploadedFiles = [];
    this.isUploading = false;

    this.loadingOverlay = options.loadingOverlay;
    this.ctmToast = options.ctmToast;
    this.showError = options.showError;
    this.hideError = options.hideError;
  }

  validateFile(file) {
    if (file.size > this.maxFileSize) {
      return `${file.name} is too large. Maximum size is 5MB.`;
    }

    if (!this.validTypes.includes(file.type)) {
      return `Please upload valid image files only: PNG, JPG, JPEG.`;
    }

    return null;
  }

  async uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    this.loadingOverlay?.show('Uploading image...');

    try {
      const response = await fetch(`${this.apiBaseUrl}/file/upload`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Image upload failed');
      const data = await response.json();

      if (!data.data) throw new Error('Invalid response from server');

      this.ctmToast?.show('Image uploaded successfully!', 2000);

      return {
        fileId: data.data,
        fileName: data.data.fileName || file.name
      };
    } catch (error) {
      throw new Error(`Upload failed: ${error.message}`);
    } finally {
      this.loadingOverlay?.hide();
    }
  }

  handleImageUpload(e, fileInput, onUploadSuccess) {
    const file = e.target.files[0];
    if (!file) return;

    if (this.isUploading) {
      return;
    }

    this.hideError?.(fileInput);

    if (this.uploadedFiles.length >= this.maxFiles) {
      this.showError?.(fileInput, `Maximum ${this.maxFiles} images allowed.`);
      fileInput.value = '';
      return;
    }

    const errorMsg = this.validateFile(file);
    if (errorMsg) {
      this.showError?.(fileInput, errorMsg);
      fileInput.value = '';
      return;
    }

    this.isUploading = true;

    this.uploadFile(file)
      .then((fileInfo) => {
        this.uploadedFiles.push(fileInfo);
        onUploadSuccess?.(this.uploadedFiles);
      })
      .catch(error => {
        this.showError?.(fileInput, error.message);
      })
      .finally(() => {
        setTimeout(() => {
          fileInput.value = '';
          this.isUploading = false;
        }, 100);
      });
  }

  generateImagePreview(fileList, className, onRemove) {
    const fragment = document.createDocumentFragment();

    fileList.forEach((file, index) => {
      const fileItem = document.createElement('div');
      fileItem.className = className || 'ctm-zoom-image-preview-item';
      fileItem.style.cssText = `
        display: flex;
        align-items: center;
        margin: 8px 0;
        padding: 8px;
        background: #f5f5f5;
        border-radius: 4px;
      `;

      const fileIcon = document.createElement('span');
      fileIcon.style.marginRight = '8px';
      fileIcon.style.fontSize = '18px';
      fileIcon.innerHTML = '🖼️';

      const fileName = document.createElement('span');
      fileName.style.color = '#5c3a1d';
      fileName.style.marginLeft = '8px';
      fileName.style.overflow = 'hidden';
      fileName.style.flex = '1';
      fileName.textContent = file.fileName;

      const removeBtn = document.createElement('span');
      removeBtn.className = 'ctm-zoom-image-preview-remove';
      removeBtn.style.marginLeft = 'auto';
      removeBtn.style.cursor = 'pointer';
      removeBtn.style.color = '#ff4444';
      removeBtn.style.fontWeight = 'bold';
      removeBtn.textContent = '×';
      removeBtn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        fileList.splice(index, 1);
        onRemove?.(fileList);
      };

      fileItem.append(fileIcon, fileName, removeBtn);
      fragment.appendChild(fileItem);
    });

    return fragment;
  }

  clearFiles() {
    this.uploadedFiles = [];
  }

  getUploadedFiles() {
    return this.uploadedFiles;
  }
}

class CtmZoomForm extends HTMLElement {
  apiBaseUrl = CtmZoomConfig.apiBaseUrl
  zoomTimeZonePath = `/zoom-meetings/timezone/list?shopId=${CtmZoomConfig.shopId}`
  zoomDateAvailabilityPath = '/zoom-meetings/date/availability'
  zoomDateRulePath = `/zoom-meetings/rule/list?serviceType=1&shopId=${CtmZoomConfig.shopId}`
  zoomCreateMeetingPath = '/zoom-meetings/create'

  timeSlotMap = {} 
  todayFullDate = '' 
  selectedFullDate = '' 
  lastSelectedDate = '' 
  dateRules = [] 
  durationPriceMap = {} 
  availableScheduleData = {} 

  selectedBooking = {
    date: '',
    timezone: '',
    time: '',
    duration: '', 
    price: '' 
  };

  uploader = null;
  fileInput = null;
  imagePreviewContainer = null;
  ctmToast = null;
  isUploadEventsBound = false;
  isFormSubmitBound = false;

  async _fetch(path, options = {}) {
    const url = path.startsWith('http') ? path : this.apiBaseUrl + path;
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
      }
    };
    
    const mergedOptions = {
      ...defaultOptions,
      ...options,
      headers: { ...defaultOptions.headers, ...options.headers }
    };

    try {
      const response = await fetch(url, mergedOptions);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error(`Fetch error [${url}]:`, error);
      throw error;
    }
  }

  formatPrice(price) {
    const p = String(price || '0');
    if (p === '0' || p === '0.00' || p.toLowerCase() === 'free') return 'Free';
    return p.startsWith('$') ? p : `$${p}`;
  }

  connectedCallback() {
    this._initElements();
    this._portalModal();
    this._portalGlobalFeedback();
    
    const today = new Date();
    this.todayFullDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    this.initUploader();

    this.initCountrySelector();
    this.initModalToggle();
    this.initCalendar();
    this.initDurationOptions();
    this.initFormSubmit();
    this.bindUploadEvents();

    this.observeBookingModule();
  }

  _modalQuerySelector(selector) {
    return this.modal?.querySelector(selector) || this.querySelector(selector);
  }

  _modalQuerySelectorAll(selector) {
    const modalMatches = this.modal?.querySelectorAll(selector);
    return modalMatches?.length ? modalMatches : this.querySelectorAll(selector);
  }

  _portalGlobalFeedback() {
    [this.loadingOverlay, this.ctmToast].forEach((el) => {
      if (el && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  _portalModal() {
    if (!this.modal || this.modal.parentNode === document.body) return;

    // Move the dialog to <body> so fixed positioning is not constrained by transformed parents.
    document.body.appendChild(this.modal);
  }

  _getActiveModalModule() {
    return this.bookingModule?.classList.contains('ctm-active') ? this.bookingModule : this.calendarModule;
  }

  _getFocusableElements(scope = this._getActiveModalModule()) {
    if (!scope) return [];
    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    return Array.from(scope.querySelectorAll(focusableSelector)).filter((el) => {
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && el.getClientRects().length > 0;
    });
  }

  _focusFirstModalElement() {
    window.requestAnimationFrame(() => {
      const focusable = this._getFocusableElements();
      focusable[0]?.focus();
    });
  }

  _trapModalFocus(event) {
    if (event.key !== 'Tab') return;

    const focusable = this._getFocusableElements();
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const activeElement = document.activeElement;

    if (!this.modal.contains(activeElement)) {
      event.preventDefault();
      first.focus();
      return;
    }

    if (event.shiftKey && activeElement === first) {
      event.preventDefault();
      last.focus();
      return;
    }

    if (!event.shiftKey && activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  _closeModal() {
    this.modal.classList.remove('ctm-active');
    this.resetForm();
    document.querySelector('html').classList.remove('js-drawer-open');
    this.modal.setAttribute('aria-hidden', 'true');
    this.previouslyFocusedElement?.focus?.();
  }

  disconnectedCallback() {
    if (this.modal?.parentNode === document.body) {
      document.body.removeChild(this.modal);
    }
  }

  _setSelectedDate(fullDate) {
    if (!fullDate) return;
    this.selectedFullDate = fullDate;
    this.lastSelectedDate = fullDate;

    const [year, month, day] = fullDate.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    
    this.selectedBooking.date = date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
    this.selectedBooking.fullDate = fullDate;
  }

  _initElements() {
    this.modal = this.querySelector('.ctm-zoom-modal');
    this.calendarModule = this.querySelector('.ctm-modal-module--calendar');
    this.bookingModule = this.querySelector('.ctm-modal-module--booking');
    this.closeBtns = this.querySelectorAll('.ctm-modal-close');
    this.backBtns = this.querySelectorAll('.ctm-modal-back-btn');
    this.bookBtn = this.querySelector('.ctm-book-btn');
    this.calendarEl = this.querySelector('.ctm-calendar');
    this.monthEl = this.querySelector('.ctm-calendar-month');
    this.prevBtn = this.querySelector('.ctm-nav-btn--prev');
    this.nextBtn = this.querySelector('.ctm-nav-btn--next');
    this.durationOptionsEls = this.querySelectorAll('.ctm-duration-options');
    this.timeSlotsEl = this.querySelector('.ctm-time-slots');
    this.confirmBtns = this.querySelectorAll('.ctm-form-btn--confirm');
    this.phoneInputContainer = this.querySelector('#ctm-phone-input-container');
    this.loadingOverlay = document.getElementById('loading-overlay');
    this.ctmToast = document.getElementById('ctm-toast');
  }

  observeBookingModule() {
    this.timeSlotsEl.addEventListener('click', () => {
      setTimeout(() => {
        this.bindUploadEvents();
      }, 100);
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (this.bookingModule.classList.contains('ctm-active') && !this.isUploadEventsBound) {
          this.bindUploadEvents();
        }
      });
    });
    observer.observe(this.bookingModule, { attributes: true, attributeFilter: ['class'] });
  }

  initUploader() {
    this.uploader = new FileUploader({
      apiBaseUrl: this.apiBaseUrl, 
      maxFileSize: 5 * 1024 * 1024, 
      loadingOverlay: this.loadingOverlay,
      ctmToast: this.ctmToast,
      showError: this.showUploadError.bind(this),
      hideError: this.hideUploadError.bind(this)
    });
  }

  bindUploadEvents() {
    if (this.isUploadEventsBound) return;
    this.isUploadEventsBound = true;

    this.fileInput = this._modalQuerySelector('.ctm-form-file-upload input');
    if (!this.fileInput) return;

    this.fileInput.accept = 'image/png, image/jpeg, image/jpg';

    if (!this.imagePreviewContainer) {
      this.imagePreviewContainer = document.createElement('div');
      this.imagePreviewContainer.className = 'ctm-zoom-image-preview-container';
      const parentLabel = this.fileInput.closest('.ctm-form-label');
      if (parentLabel) {
        parentLabel.after(this.imagePreviewContainer);
      } else {
        this.fileInput.parentNode.after(this.imagePreviewContainer);
      }
    }

    const handleFileChange = (e) => {
      this.uploader.handleImageUpload(
        e,
        this.fileInput,
        (fileList) => {
          this.updateImagePreview(fileList); 
          this._validateFile();
        }
      );
    };
    this.fileInput.addEventListener('change', handleFileChange);

    this.fileInput.addEventListener('click', () => {
      this.fileInput.value = '';
    });
  }

  updateImagePreview(fileList) {
    this.imagePreviewContainer.innerHTML = '';
    const previewDOM = this.uploader.generateImagePreview(
      fileList,
      'ctm-zoom-image-preview-item',
      (updatedFiles) => {
        this.uploader.uploadedFiles = updatedFiles;
        this.updateImagePreview(updatedFiles);
        this._validateFile();
      }
    );
    this.imagePreviewContainer.appendChild(previewDOM);

    const errorEl = document.getElementById('error-4');
    if (errorEl && fileList.length > 0) {
      errorEl.style.display = 'none';
    }
  }

  showUploadError(element, message) {
    let errorEl = element.closest('.ctm-form-label').querySelector('.ctm-upload-error');
    if (!errorEl) {
      const label = element.closest('.ctm-form-label');
      errorEl = document.createElement('div');
      errorEl.className = 'ctm-upload-error';
      label.appendChild(errorEl);
    }
    errorEl.textContent = message;
    errorEl.style.display = 'block';
  }

  hideUploadError(element) {
    const errorEl = element.closest('.ctm-form-label').querySelector('.ctm-upload-error');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  resetForm() {
    const form = document.getElementById('ctm-booking-form');
    if (form) form.reset();

    if (this.uploader) {
      this.uploader.clearFiles();
    }

    if (this.imagePreviewContainer) {
      this.imagePreviewContainer.innerHTML = '';
    }

    this.selectedFullDate = '';
    this.lastSelectedDate = '';
    this.selectedBooking = {
      date: '',
      time: '',
      duration: '',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      price: ''
    };

    this._modalQuerySelectorAll('.ctm-form-error, .ctm-upload-error').forEach(el => {
      el.style.display = 'none';
    });
  }

  initCountrySelector() {
    const countrySelect = document.getElementById('ctm-country-select');
    const flagImg = document.querySelector('.ctm-phone-country-flag');
    const dialCodeSpan = document.getElementById('ctm-phone-dial-code');
    const countryWrapper = this._modalQuerySelector('.ctm-phone-country-wrapper');
    const phoneInput = document.getElementById('ctm-question-phone');

    if (!countrySelect || !flagImg) return;

    const adjustPadding = () => {
      if (countryWrapper && phoneInput) {
        const width = countryWrapper.offsetWidth;
        phoneInput.style.paddingLeft = `${width + 4}px`;
      }
    };

    if (window.ResizeObserver && countryWrapper) {
      new ResizeObserver(() => adjustPadding()).observe(countryWrapper);
    }

    COUNTRY_LIST.forEach(country => {
      const option = document.createElement('option');
      option.value = country.code;
      option.textContent = country.name;
      if (country.code === 'US') option.selected = true;
      countrySelect.appendChild(option);
    });

    countrySelect.addEventListener('change', (e) => {
      const selectedCode = e.target.value;
      const selectedCountry = COUNTRY_LIST.find(c => c.code === selectedCode);
      if (selectedCountry) {
        flagImg.alt = selectedCountry.name;
        flagImg.src = `https://purecatamphetamine.github.io/country-flag-icons/3x2/${selectedCode}.svg`;
        if (dialCodeSpan) {
          dialCodeSpan.textContent = selectedCountry.dial_code || '';
        }
        setTimeout(adjustPadding, 0);
      }
    });

    const initialCountry = COUNTRY_LIST.find(c => c.code === 'US');
    if (initialCountry) {
      if (dialCodeSpan) dialCodeSpan.textContent = initialCountry.dial_code || '';
      adjustPadding();
    }
  }

  initModalToggle() {
    this.bookBtn.addEventListener('click', async () => {
      this.previouslyFocusedElement = document.activeElement;
      this.modal.classList.add('ctm-active');
      this.modal.setAttribute('aria-hidden', 'false');
      this.calendarModule.classList.add('ctm-active');
      this.bookingModule.classList.remove('ctm-active');
      document.querySelector('html').classList.add('js-drawer-open');
      this._focusFirstModalElement();
      this.initTimezone();

      try {
        await this.initDateRules();
        
        const firstDuration = this.dateRules[0];
        if (!firstDuration) {
          throw new Error('No duration data from rule API');
        }

        this.selectedBooking.duration = firstDuration;
        this.selectedBooking.price = this.formatPrice(this.durationPriceMap[firstDuration]);
        this.selectedBooking.productId = this.durationProductMap[firstDuration] || '';

        await this.initZoomAvailableTime(firstDuration);

        if (Object.keys(this.availableScheduleData).length > 0) {
          const nearestDate = this.getNearestAvailableDateForCurrentDuration();
          if (nearestDate) {
            this._setSelectedDate(nearestDate);
            const [year, month] = nearestDate.split('-').map(Number);
            this.viewYear = year;
            this.viewMonth = month;
          }
        }
        
        this.renderCalendar();
        this.updateDurationOptions();

        if (this.selectedFullDate && this.selectedBooking.duration) {
          this.renderTimeSlots(this.selectedBooking.duration);
        }
      } catch (error) {
        this.ctmToast.show(error.message || 'Failed to load booking data');
        this.renderCalendar();
        this.updateDurationOptions();
      }
      document.querySelector('html').classList.add('js-drawer-open');
      document.querySelectorAll('.cowlendar-root').forEach(el => el.remove());
      if (window.gtag) {
        window.gtag('event', 'custom_event', {
          'ctm_custom_event': 'zoom_open'
        });
      }
    });

    this.closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        this._closeModal();
      });
    });

    this.modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this._closeModal();
        return;
      }
      this._trapModalFocus(e);
    });

    this.backBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        this.bookingModule.classList.remove('ctm-active');
        this.calendarModule.classList.add('ctm-active');
        this.isUploadEventsBound = false;
        this._focusFirstModalElement();
      });
    });
  }

  getNearestAvailableDateForCurrentDuration() {
    const currentDuration = this.selectedBooking.duration;
    if (!currentDuration) return null;

    const availableDates = Object.keys(this.availableScheduleData).filter(date => {
      const dayDurationMap = this.availableScheduleData[date] || {};
      return !!dayDurationMap[currentDuration] && dayDurationMap[currentDuration].length > 0;
    }).sort();

    if (availableDates.length === 0) return null;

    if (availableDates.includes(this.todayFullDate)) {
      return this.todayFullDate;
    }

    for (const date of availableDates) {
      if (date > this.todayFullDate) {
        return date;
      }
    }

    return availableDates[0];
  }

  checkDateHasDurationSlots(date) {
    const currentDuration = this.selectedBooking.duration;
    if (!date || !currentDuration) return false;

    const dayDurationMap = this.availableScheduleData[date] || {};
    return !!dayDurationMap[currentDuration] && dayDurationMap[currentDuration].length > 0;
  }

  async initTimezone() {
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    try {
      const data = await this._fetch(this.zoomTimeZonePath);

      if (data.code !== 200) {
        this.ctmToast.show(data.message);
        this.setDefaultTimezone('America/New_York');
        return;
      }

      const display = document.getElementById('ctm-timezone-display');
      const dropdown = document.getElementById('ctm-timezone-dropdown');
      const searchInput = document.getElementById('ctm-timezone-search');
      const list = document.getElementById('ctm-timezone-list');

      if (!display || !dropdown || !searchInput || !list) {
        this.setDefaultTimezone('America/New_York');
        return;
      }

      this.timezoneData = data.data || [];
      let isMatched = false;

      const renderTimezoneList = (filter = '') => {
        list.innerHTML = '';
        const filteredTimezones = this.timezoneData.filter(tz => 
          tz.toLowerCase().includes(filter.toLowerCase())
        );

        filteredTimezones.forEach(timezone => {
          const li = document.createElement('li');
          li.className = 'ctm-timezone-item';
          li.textContent = timezone;
          li.dataset.value = timezone;
          li.setAttribute('role', 'option');
          
          if (timezone === this.selectedBooking.timezone) {
            li.classList.add('selected');
            li.setAttribute('aria-selected', 'true');
          }

          li.addEventListener('click', async () => {
            this.selectedBooking.timezone = timezone;
            display.querySelector('.ctm-timezone-value').textContent = timezone;
            dropdown.classList.remove('active');
            display.setAttribute('aria-expanded', 'false');
            searchInput.value = '';
            renderTimezoneList();
            
            if (this.bookingModule.classList.contains('ctm-active')) {
              this.fillBookingInfo();
            }
            await this.initZoomAvailableTime(this.selectedBooking.duration);
          });

          list.appendChild(li);
        });
      };

      this.timezoneData.forEach(timezone => {
        if (timezone === browserTimezone) {
          isMatched = true;
          this.selectedBooking.timezone = timezone;
          display.querySelector('.ctm-timezone-value').textContent = timezone;
        }
      });

      if (!isMatched) {
        const defaultTimezone = 'America/New_York';
        this.selectedBooking.timezone = defaultTimezone;
        display.querySelector('.ctm-timezone-value').textContent = defaultTimezone;
      }

      renderTimezoneList();

      display.addEventListener('click', (e) => {
        e.stopPropagation();
        dropdown.classList.toggle('active');
        display.setAttribute('aria-expanded', dropdown.classList.contains('active') ? 'true' : 'false');
        if (dropdown.classList.contains('active')) {
          searchInput.focus();
        }
      });

      searchInput.addEventListener('input', (e) => {
        renderTimezoneList(e.target.value);
      });

      searchInput.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      document.addEventListener('click', (e) => {
        if (!display.contains(e.target) && !dropdown.contains(e.target)) {
          dropdown.classList.remove('active');
          searchInput.value = '';
          renderTimezoneList();
        }
      });
    } catch (error) {
      this.setDefaultTimezone('America/New_York');
    }
  }

  setDefaultTimezone(defaultValue) {
    const display = document.getElementById('ctm-timezone-display');
    if (display) {
      display.querySelector('.ctm-timezone-value').textContent = defaultValue;
      this.selectedBooking.timezone = defaultValue;
    }
  }

  async initZoomAvailableTime(selectedDuration) {
    if (!selectedDuration) {
      return;
    }
    const timezone = this.selectedBooking.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
    const durationValue = selectedDuration.replace(' minutes', '');
    const path = `${this.zoomDateAvailabilityPath}`;

    try {
      const data = await this._fetch(path, {
        method: 'POST',
        body: JSON.stringify({
          duration: durationValue,
          timezone: timezone,
          shopId: CtmZoomConfig.shopId
        })
      });

      if (data.code !== 200) {
        this.ctmToast.show(data.message);
        this.availableScheduleData = {};
        this.renderCalendar();
        throw new Error(data.message);
      }

      if (!data.data?.canScheduleList?.length) {
        this.ctmToast.show('No available date');
        this.availableScheduleData = {};
        this.renderCalendar();
        return 
      }

      this.parseScheduleData(data.data);
      this.updateDurationOptions();
      this.renderTimeSlots(selectedDuration);
      this.renderCalendar();
    } catch (error) {
      this.availableScheduleData = {};
      this.renderCalendar();
      this.updateDurationOptions();
      this.renderTimeSlots(selectedDuration);
    }
  }

  async initDateRules() {
    try {
      const data = await this._fetch(this.zoomDateRulePath);

      this.dateRules = [];
      this.durationPriceMap = {};
      this.durationProductMap = {};

      if (data.code !== 200) {
        this.ctmToast.show(data.message);
      }

      const rules = data.data || [];
      if (rules.length === 0) {
        this.ctmToast.show('No available duration rules');
      }

      const durationSet = new Set();
      rules.forEach(rule => {
        if (rule.duration) {
          const durationKey = `${rule.duration} minutes`;
          durationSet.add(durationKey);
          this.durationPriceMap[durationKey] = rule.price || '0';
          this.durationProductMap[durationKey] = rule.productId || '';
        }
      });
      this.dateRules = Array.from(durationSet);
    } catch (error) {
      this.ctmToast.show('Network error, failed to load duration rules');
      this.dateRules = [];
      this.durationPriceMap = {};
      throw error;
    }
  }

  parseScheduleData(scheduleData) {
    const scheduleMap = {};
    scheduleData.canScheduleList.forEach(dayItem => {
      const date = dayItem.date; 
      const detailList = dayItem.detailList || [];

      const durationMap = {};
      detailList.forEach(detail => {
        const durationKey = `${detail.duration} minutes`;
        if (!durationMap[durationKey]) {
          durationMap[durationKey] = [];
        }

        const timeRange = `${detail.startTime} - ${detail.endTime}`;
        
        const slotLeft = detail.bookLeft || 0;
        const price = this.durationPriceMap[durationKey];
        const priceText = this.formatPrice(price);
        const tags = [`${slotLeft} SLOT${slotLeft > 1 ? 'S' : ''} LEFT`, priceText];

        durationMap[durationKey].push({
          time: timeRange,
          tags: tags,
          price: priceText, 
          raw: detail
        });
      });

      scheduleMap[date] = durationMap;
    });

    this.availableScheduleData = scheduleMap;
    if (scheduleData.timezone) {
      this.selectedBooking.timezone = scheduleData.timezone;
    }
  }

  initCalendar() {
    const now = new Date();
    this.baseYear = now.getFullYear();
    this.baseMonth = now.getMonth() + 1;
    this.viewYear = this.baseYear;
    this.viewMonth = this.baseMonth;
    this.min = this.calcYM(this.baseYear, this.baseMonth - 1);
    this.max = this.calcYM(this.baseYear, this.baseMonth + 1);

    this.prevBtn?.addEventListener('click', () => {
      this.changeMonth(-1);
    });
    this.nextBtn?.addEventListener('click', () => {
      this.changeMonth(1);
    });
    this.renderCalendar();
  }

  calcYM(year, month) {
    if (month === 0) return { year: year - 1, month: 12 };
    if (month === 13) return { year: year + 1, month: 1 };
    return { year, month };
  }

  renderCalendar() {
    this.renderMonthTitle();
    this.renderCalendarDays();
    this.updateNavState();

    if (this.selectedFullDate) {
      const selectedDayEl = this.calendarEl.querySelector(`.ctm-day[data-date="${this.selectedFullDate}"]`);
      if (selectedDayEl) {
        selectedDayEl.classList.add('ctm-day-selected'); 
      }
    }
  }

  renderMonthTitle() {
    const date = new Date(this.viewYear, this.viewMonth - 1);
    this.monthEl.textContent = date.toLocaleString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  }

  renderCalendarDays() {
    const cal = this.calendarEl;
    cal.innerHTML = '';

    const weeks = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    weeks.forEach(w => {
      const el = document.createElement('div');
      el.className = 'ctm-week';
      el.textContent = w;
      cal.appendChild(el);
    });

    const first = new Date(this.viewYear, this.viewMonth - 1, 1);
    const daysInMonth = new Date(this.viewYear, this.viewMonth, 0).getDate();
    let start = first.getDay();
    start = start === 0 ? 7 : start;

    for (let i = 1; i < start; i++) {
      cal.appendChild(this.createDay('', true));
    }

    for (let d = 1; d <= daysInMonth; d++) {
      const monthStr = String(this.viewMonth).padStart(2, '0');
      const dayStr = String(d).padStart(2, '0');
      const fullDate = `${this.viewYear}-${monthStr}-${dayStr}`;
      const dayEl = this.createDay(d, false, fullDate);
      dayEl.setAttribute('data-date', fullDate); 
      cal.appendChild(dayEl);
    }
  }

  createDay(day, muted = false, fullDate = '') {
    const el = document.createElement(day && !muted ? 'button' : 'span');
    el.className = 'ctm-day';
    if (el.tagName === 'BUTTON') el.type = 'button';

    if (!day || muted) {
      el.classList.add('ctm-muted');
      el.textContent = day;
      return el;
    }

    el.textContent = day;
    const isToday = fullDate === this.todayFullDate;
    const isAvailable = this.isFreeDay(day, fullDate);
    const isSelected = fullDate === this.selectedFullDate; 

    if (isToday) {
      const todayDot = document.createElement('span');
      todayDot.className = 'ctm-day-today-dot';
      todayDot.setAttribute('aria-hidden', 'true');
      el.appendChild(todayDot);
    }

    if (isSelected) {
      el.classList.add('ctm-day-selected'); 
    }

    if (isAvailable) {
      let displayText = 'Free';
      const currentDuration = this.selectedBooking.duration;

      const dayDurationMap = this.availableScheduleData[fullDate] || {};
      if (currentDuration && dayDurationMap[currentDuration] && this.durationPriceMap[currentDuration] !== undefined) {
        displayText = this.formatPrice(this.durationPriceMap[currentDuration]);
      } 


      const priceEl = document.createElement('div');
      priceEl.className = 'ctm-zoom-price';
      priceEl.textContent = displayText;
      el.appendChild(priceEl);

      el.addEventListener('click', () => {
        this.calendarEl.querySelectorAll('.ctm-day').forEach(item => {
          item.classList.remove('ctm-day-selected');
        });
        el.classList.add('ctm-day-selected');
        this._setSelectedDate(fullDate);

        this.renderTimeSlots(this.selectedBooking.duration);
      });
    } else {
      el.classList.add('ctm-disabled');
      el.disabled = true;
      el.setAttribute('aria-disabled', 'true');
    }

    return el;
  }

  updateDurationOptions() {
    this.durationOptionsEls.forEach(container => container.innerHTML = '');
    const availableDurations = this.dateRules;

    if (availableDurations.length === 0) {
      const emptyEl = document.createElement('div');
      emptyEl.className = 'ctm-empty-tip';
      emptyEl.textContent = 'No available durations';
      emptyEl.classList.add('ctm-empty-tip--inline');
      this.durationOptionsEls.forEach(container => container.appendChild(emptyEl.cloneNode(true)));
      this.timeSlotsEl.innerHTML = '';
      const slotEmptyEl = document.createElement('div');
      slotEmptyEl.className = 'ctm-time-slot-empty';
      slotEmptyEl.textContent = 'No available time slots';
      this.timeSlotsEl.appendChild(slotEmptyEl);
      return;
    }

    availableDurations.forEach(duration => {
      this.durationOptionsEls.forEach(container => {
        const el = document.createElement('button');
        el.type = 'button';
        el.className = `ctm-duration ${duration === this.selectedBooking.duration ? 'ctm-active' : ''}`;
        el.dataset.duration = duration; 
        el.textContent = duration;

        el.addEventListener('click', async () => {
          this._modalQuerySelectorAll('.ctm-duration').forEach(item => {
            if (item.dataset.duration === duration) {
              item.classList.add('ctm-active');
            } else {
              item.classList.remove('ctm-active');
            }
          });

          this.selectedBooking.duration = duration;
          this.selectedBooking.price = this.formatPrice(this.durationPriceMap[duration]);
          this.selectedBooking.productId = this.durationProductMap[duration] || '';

          try {
            await this.initZoomAvailableTime(duration);
            
            if (this.lastSelectedDate) {
              if (this.checkDateHasDurationSlots(this.lastSelectedDate)) {
                this._setSelectedDate(this.lastSelectedDate);
                const [year, month] = this.lastSelectedDate.split('-').map(Number);
                this.viewYear = year;
                this.viewMonth = month;
              } else {
                const nearestDate = this.getNearestAvailableDateForCurrentDuration();
                if (nearestDate) {
                  this._setSelectedDate(nearestDate);
                  const [year, month] = nearestDate.split('-').map(Number);
                  this.viewYear = year;
                  this.viewMonth = month;
                }
              }
            } else {
              const nearestDate = this.getNearestAvailableDateForCurrentDuration();
              if (nearestDate) {
                this._setSelectedDate(nearestDate);
                const [year, month] = nearestDate.split('-').map(Number);
                this.viewYear = year;
                this.viewMonth = month;
              }
            }
            this.renderCalendar();
            this.renderTimeSlots(duration);
          } catch (error) {
            console.error('Duration change error:', error);
          }
        });
        container.appendChild(el);
      });
    });
  }

  isFreeDay(day, fullDate) {
    return !!this.availableScheduleData[fullDate];
  }

  changeMonth(step) {
    const next = this.calcYM(this.viewYear, this.viewMonth + step);
    if (!this.isWithinRange(next)) return;
    this.viewYear = next.year;
    this.viewMonth = next.month;
    this.renderCalendar();
  }

  isWithinRange({ year, month }) {
    const toNum = v => v.year * 100 + v.month;
    return toNum({ year, month }) >= toNum(this.min) && toNum({ year, month }) <= toNum(this.max);
  }

  updateNavState() {
    const toNum = v => v.year * 100 + v.month;
    const cur = toNum({ year: this.viewYear, month: this.viewMonth });
    this.prevBtn.classList.toggle('ctm-disabled', cur <= toNum(this.min));
    this.nextBtn.classList.toggle('ctm-disabled', cur >= toNum(this.max));
  }

  initDurationOptions() {
    this.durationOptionsEls.forEach(container => {
      container.innerHTML = '';
      const loadingEl = document.createElement('div');
      loadingEl.className = 'ctm-loading';
      loadingEl.textContent = 'Loading durations...';
      container.appendChild(loadingEl);
    });
  }

  renderTimeSlots(duration) {
    this.timeSlotsEl.innerHTML = '';

    if (this.dateRules.length === 0) {
      const emptyEl = document.createElement('div');
      emptyEl.className = 'ctm-time-slot-empty';
      emptyEl.textContent = 'No available time slots';
      this.timeSlotsEl.appendChild(emptyEl);
      return;
    }

    if (!this.selectedFullDate) {
      const emptyEl = document.createElement('div');
      emptyEl.className = 'ctm-time-slot-empty';
      emptyEl.textContent = 'Please select a date first';
      this.timeSlotsEl.appendChild(emptyEl);
      return;
    }

    const fullDate = this.selectedFullDate;
    const dayDurationMap = this.availableScheduleData[fullDate] || {};
    const slots = dayDurationMap[duration] || [];

    if (slots.length === 0) {
      const emptyEl = document.createElement('div');
      emptyEl.className = 'ctm-time-slot-empty';
      emptyEl.textContent = 'No available time slots for this duration';
      this.timeSlotsEl.appendChild(emptyEl);
      return;
    }

    slots.forEach(slot => {
      const el = document.createElement('button');
      el.type = 'button';
      el.className = 'ctm-time-slot';

      const timeSpan = document.createElement('span');
      timeSpan.textContent = slot.time;
      timeSpan.classList = 'ctm-time-item';
      el.appendChild(timeSpan);

      const tagsDiv = document.createElement('div');
      tagsDiv.className = 'ctm-tags';
      slot.tags.forEach(tag => {
        const tagSpan = document.createElement('span');
        tagSpan.textContent = tag;
        tagsDiv.appendChild(tagSpan);
      });
      el.appendChild(tagsDiv);

      el.addEventListener('click', () => {
        this.selectedBooking.time = slot.time;
        this.selectedBooking.price = this.formatPrice(slot.price);
        this.fillBookingInfo();
        this.calendarModule.classList.remove('ctm-active');
        this.bookingModule.classList.add('ctm-active');
      });

      this.timeSlotsEl.appendChild(el);
    });
  }

  fillBookingInfo() {
    document.getElementById('ctm-booking-date').textContent = this.selectedBooking.date;
    document.getElementById('ctm-booking-timezone').textContent = this.selectedBooking.timezone;
    document.getElementById('ctm-booking-time').textContent = this.selectedBooking.time;
    document.getElementById('ctm-booking-duration').textContent = this.selectedBooking.duration;
    document.getElementById('ctm-booking-price').textContent = this.selectedBooking.price;
  }

  initFormSubmit() {
    if (this.isFormSubmitBound) return;
    this.isFormSubmitBound = true;

    const form = document.getElementById('ctm-booking-form');
    if (!form) return;

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    const allSubmitBtns = document.querySelectorAll('.ctm-form-btn--confirm');
    allSubmitBtns.forEach(btn => {
      btn.addEventListener('click', (e) => this._handleSubmit(e));
    });

    const requiredInputs = [
      { id: 'ctm-question-name', errorId: 'error-name' },
      { id: 'ctm-question-email', errorId: 'error-email' },
      { id: 'ctm-question-phone', errorId: 'error-phone' },
      { id: 'ctm-question-2', errorId: 'error-2' },
      { id: 'ctm-question-7', errorId: 'error-7' }
    ];

    requiredInputs.forEach(item => {
      const input = document.getElementById(item.id);
      const errorEl = document.getElementById(item.errorId);
      if (input && errorEl) {
        input.addEventListener('input', () => {
          if (item.id === 'ctm-question-phone' || item.id === 'ctm-question-2') {
            input.value = input.value.replace(/\D/g, '');
          }

          if (input.checkValidity() && input.value.trim() !== '') {
            errorEl.style.display = 'none';
          }
        });
      }
    });

    const radioInputs = document.querySelectorAll('input[name="ctm-question-0"]');
    radioInputs.forEach(radio => {
      radio.addEventListener('click', () => this._validateRadio());
    });

    const checkboxWrappers = document.querySelectorAll('.ctm-form-checkbox-group');
    checkboxWrappers.forEach(wrapper => {
      wrapper.addEventListener('change', (e) => {
        const name = e.target.getAttribute('name');
        if (name) this._validateCheckboxGroup(name);
      });
    });


  }

  _validateTextInputs() {
    let isValid = true;
    const rules = [
      { 
        id: 'ctm-question-name', 
        errorId: 'error-name', 
        emptyMsg: 'Please enter your name',
        validate: (val) => val.length <= 50,
        invalidMsg: 'Name cannot exceed 50 characters'
      },
      { 
        id: 'ctm-question-email', 
        errorId: 'error-email', 
        emptyMsg: 'Please enter your email address', 
        validate: (val) => /^[^\s@]+@[^\s@]+(\.[^\s@.。]+)+$/.test(val),
        invalidMsg: 'Please enter a valid email address' 
      },
      { 
        id: 'ctm-question-phone', 
        errorId: 'error-phone', 
        emptyMsg: 'Please enter your phone number',
        validate: (val) => val.length >= 7 && val.length <= 15,
        invalidMsg: 'Phone number must be between 7 and 15 digits'
      },
      { 
        id: 'ctm-question-2', 
        errorId: 'error-2', 
        emptyMsg: 'Please enter the number of windows',
        validate: (val) => {
          const num = parseInt(val);
          return !isNaN(num) && num > 0 && num <= 100;
        },
        invalidMsg: 'Please enter a valid number (1-100)'
      },
      {
        id: 'ctm-question-7',
        errorId: 'error-7',
        validate: (val) => val.length <= 200,
        invalidMsg: 'Notes cannot exceed 200 characters',
        optional: true
      }
    ];

    rules.forEach(item => {
      const input = document.getElementById(item.id);
      const errorEl = document.getElementById(item.errorId);
      if (!input || !errorEl) return;

      const val = input.value.trim();
      const isEmpty = val === '';

      if (!item.optional && isEmpty) {
        errorEl.textContent = item.emptyMsg;
        errorEl.style.display = 'block';
        isValid = false;
        return;
      }

      if (!isEmpty && item.validate && !item.validate(val)) {
        errorEl.textContent = item.invalidMsg || (item.optional ? '' : item.emptyMsg);
        errorEl.style.display = 'block';
        isValid = false;
      } else {
        errorEl.style.display = 'none';
      }
    });
    return isValid;
  }

  _validateRadio() {
    const radioGroup = document.querySelectorAll('input[name="ctm-question-0"]');
    const errorEl = document.getElementById('error-0');
    if (!radioGroup.length || !errorEl) return true;

    const isChecked = Array.from(radioGroup).some(radio => radio.checked);
    errorEl.style.display = isChecked ? 'none' : 'block';
    return isChecked;
  }

  _validateCheckboxGroup(targetName = null) {
    let isValid = true;
    const checkboxGroups = [
      { name: 'ctm-question-1', errorId: 'error-1' },
      { name: 'ctm-question-3', errorId: 'error-3' }
    ];

    checkboxGroups.forEach(group => {
      if (targetName && targetName !== group.name) return;

      const checkboxes = document.querySelectorAll(`input[name="${group.name}"]`);
      const errorEl = document.getElementById(group.errorId);
      if (!checkboxes.length || !errorEl) return;

      const isChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
      errorEl.style.display = isChecked ? 'none' : 'block';
      if (!isChecked) isValid = false;
    });
    return isValid;
  }

  _validateFile() {
    const errorEl = document.querySelector('.ctm-upload-error');
    if (!this.uploader || !errorEl) return true;

    if (this.uploader.isUploading) {
      errorEl.style.display = 'none';
      return true;
    }

    const uploadedFiles = this.uploader.getUploadedFiles();
    const hasFiles = uploadedFiles.length > 0;
    
    if (!hasFiles) {
      errorEl.textContent = 'Please upload a file';
      errorEl.style.display = 'block';
    } else {
      errorEl.style.display = 'none';
    }
    return hasFiles;
  }

  _validateForm() {
    const isTextValid = this._validateTextInputs();
    const isRadioValid = this._validateRadio();
    const isCheckboxValid = this._validateCheckboxGroup();
    const isFileValid = this._modalQuerySelector('#ctm-question-4') ? this._validateFile() : true;

    const isValid = isTextValid && isRadioValid && isCheckboxValid && isFileValid;

    if (!isValid) {
      const firstError = document.querySelector('.ctm-form-error[style*="block"], .ctm-upload-error[style*="block"]');
      if (firstError) {
        const formGroup = firstError.closest('.ctm-form-group') || firstError.closest('.ctm-form-checkbox-group');
        if (formGroup) formGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    return isValid;
  }

  async _handleSubmit(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (!this._validateForm()) return;

    try {
      if (this.loadingOverlay) this.loadingOverlay.show('Submitting booking...');

      const form = document.getElementById('ctm-booking-form');
      const formData = new FormData(form);

      const datePart = this.selectedFullDate || this.todayFullDate;
      const timePart = (this.selectedBooking.time.split('-')[0] || '00:00').trim();
      const startTime = `${datePart} ${timePart}:00`;
      const duration = parseInt(this.selectedBooking.duration) || 20;

      const getCheckedValues = (name) => {
        return Array.from(document.querySelectorAll(`input[name="${name}"]:checked`))
          .map(el => el.value)
          .join(',');
      };

      const windowsImages = this.uploader.getUploadedFiles()
        .map(file => file.fileId)
        .join(',');

      const dialCode = document.getElementById('ctm-phone-dial-code')?.textContent || '';
      const rawPhone = formData.get('ctm-phone-input-field') || '';

      const payload = {
        email: formData.get('ctm-question-email'),
        userName: formData.get('ctm-question-name'),
        phone: `${dialCode} ${rawPhone}`,
        startTime: startTime,
        serviceType: 1,
        duration: duration,
        meetingDetailData: {
          windowsNum: parseInt(formData.get('ctm-question-2')) || 0,
          roomType: getCheckedValues('ctm-question-3'),
          windowTreatmentType: getCheckedValues('ctm-question-1'),
          windowsImage: windowsImages,
          favorite: getCheckedValues('ctm-question-5'),
          preferred: getCheckedValues('ctm-question-6'),
          addNode: formData.get('ctm-question-7') || ''
        },
        timezone: this.selectedBooking.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
        shopId: CtmZoomConfig.shopId
      };
      const result = await this._fetch(this.zoomCreateMeetingPath, {
        method: 'POST',
        headers: {
        },
        body: JSON.stringify(payload)
      });

      if (result.code === 200) {
        const cartPayload = {
          items: [{
            id: this.selectedBooking.productId,
            quantity: 1,
            properties: {
              _zoom_meeting_record_id: String(result.data)
            }
          }]
        };

        const cartAddUrl = CtmZoomConfig.cartAddUrl;
        const cartResponse = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cartPayload)
        });

        if (cartResponse.ok) {
          const form = document.querySelector('#ctm-booking-form');
          if (form) form.reset();
          
          const checkoutBtn = document.querySelector('cart-drawer button[name="checkout"], #CartDrawer button[name="checkout"], form[action*="/cart"] button[name="checkout"], button[name="checkout"]');
          if (this.loadingOverlay) this.loadingOverlay.show('Redirecting to checkout...');
          if (checkoutBtn) {
            checkoutBtn.click();
          } else {
            window.location.href = CtmZoomConfig.checkoutUrl;
          }
        } else {
          const cartError = await cartResponse.json();
          throw new Error(cartError.message || 'Failed to add item to cart');
        }
      } else {
        this.ctmToast.show(result.message || 'Booking failed');
      }
    } catch (error) {
      this.ctmToast.show(error.message || 'Booking failed');
    } finally {
      if (this.loadingOverlay) this.loadingOverlay.hide();
    }
  }
}

if (!customElements.get('ctm-zoom-form')) {
  customElements.define('ctm-zoom-form', CtmZoomForm);
}
